module.exports = "<span tooltip=\"{{titulo}}\" placement=\"top\" show-delay=\"300\" theme=\"light\">\n  <i class=\"fas fa-info-circle color\"></i>\n</span>"